<template>
  <div style="width: 100%" :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="about-company">
        <div class="wow fadeInUp" style="display: flex;align-items: center;flex-direction: column;">
          <div class="title">{{$t('aboutUs.company')}}</div>
        </div>
        <div class="company">
          <div class="introduction-ol">
            <div class="introduction wow fadeInUp">
<!--              <p>{{$t('aboutUs.logo')}}</p>-->
              <span>
<!--                {{$t('aboutUs.message0.message01')}}-->
              </span>
              <span>
<!--                {{$t('aboutUs.message0.message02')}}-->
              </span>
              <span>
<!--                {{$t('aboutUs.message0.message03')}}-->
              </span>
            </div>
          </div>
          <img src="../../../assets/img/aboutus/zlgj-company.jpg" class="img-fluid">
        </div>
        <div class="slogan">
          <div class="slogan-compent wow fadeInUp">
            <div>
            <div class="mission">
              <div class="title">{{$t('aboutUs.mission')}}</div>
              <div class="tips">{{$t('aboutUs.tip')}}</div>
            </div>
            <div class="vision">
              <div class="title">{{$t('aboutUs.vision')}}</div>
              <div class="tips">{{$t('aboutUs.tip1')}}</div>
            </div>
            </div>
          </div>
          <img src="../../../assets/img/aboutus/slogan.jpg" class="img-fluid" @load="loadImg">
        </div>
        <div class="culture">
          <div ref="cultureContent" class="culture-content-ol">
            <div class="culture-content wow fadeInUp">
              <p>{{$t('aboutUs.culture')}}</p>
              <div class="culture-menu">
                <div class="culture-item" v-for="item in cultureItems">
                  <img :src="item.img" v-show="lang == 'CN'">
                  <div class="note">
                    <span class="note-cn" v-show="lang == 'CN'">{{item.noteCn}}</span>
                    <span class="note-en" v-show="lang == 'EN'">{{item.noteEn}}</span>
                    <span class="note-ru" v-show="lang == 'RU'">{{item.noteRu}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img @load="loadImg" ref="cultureBanner" class="img-fluid"
               src="../../../assets/img/aboutus/culture_banner.png">
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="about-company">
        <div class="wow fadeInUp" style="display: flex;align-items: center;flex-direction: column;">
          <div class="title">{{$t('aboutUs.company')}}</div>
        </div>
        <div class="company">
          <img src="../../../assets/img/aboutus/zlgj-company.jpg" style="margin: 0;padding: 0;">
          <div class="introduction-ol">
            <div class="introduction wow fadeInUp">
              <p>{{$t('aboutUs.logo')}}</p>
              <span>
                {{$t('aboutUs.message0.message01')}}
              </span>
<!--              <span>-->
<!--                {{$t('aboutUs.message0.message02')}}-->
<!--              </span>-->
<!--              <span>-->
<!--                {{$t('aboutUs.message0.message03')}}-->
<!--              </span>-->
            </div>
          </div>
        </div>
        <div class="slogan">
          <div class="slogan-compent wow fadeInUp">
            <div>
              <div class="mission">
                <div class="title">{{$t('aboutUs.mission')}}</div>
                <div class="tips">{{$t('aboutUs.tip')}}</div>
              </div>
              <div class="vision">
                <div class="title">{{$t('aboutUs.vision')}}</div>
                <div class="tips">{{$t('aboutUs.tip1')}}</div>
              </div>
            </div>
          </div>
          <img class="wow fadeInUp img-fluid" src="../../../assets/img/aboutus/slogan-xs.jpg">
        </div>
        <div class="culture">
          <div ref="cultureContent" class="culture-content-ol">
            <div class="culture-content wow fadeInUp">
              <p>{{$t('aboutUs.culture')}}</p>
              <div class="culture-menu">
                <div class="culture-item" v-for="item in cultureItems">
                  <img :src="item.img" v-show="lang == 'CN'">
                  <div class="note">
                    <span class="note-cn" v-if="lang == 'CN'">{{item.noteCn}}</span>
                    <span class="note-cn" v-if="lang == 'EN'">{{item.noteEn}}</span>
                    <span class="note-cn" v-if="lang == 'RU'">{{item.noteRu}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img class="img-fluid culture-img" src="../../../assets/img/aboutus/culture_banner.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'AboutCompany',
    components: {},
    props: {},
    data() {
      return {
        cultureItems: [
          // {
          //   img: require('../../../assets/img/aboutus/item_chuang.png'),
          //   noteCn: '挑战创新',
          //   noteEn: 'Challenge & Innovation'
          // },
          // {
          //   img: require('../../../assets/img/aboutus/item_jiang.png'),
          //   noteCn: '工匠精神',
          //   noteEn: 'Craftsmanship'
          // },
          {
            img: require('../../../assets/img/aboutus/item_xie.png'),
            noteCn: '协作共赢',
            noteEn: 'Collaboration for Winning',
            noteRu: 'совместный выигрыш'
          },
          {
            img: require('../../../assets/img/aboutus/item_cheng.png'),
            noteCn: '至诚至信',
            noteEn: 'Integrity Leads to Trust',
            noteRu: 'искренний и искренний'

          },
          {
            img: require('../../../assets/img/aboutus/item_jing.png'),
            noteCn: '友爱敬业',
            noteEn: 'Commitment & Care',
            noteRu: 'дружелюбие и преданность'
          },
          {
            img: require('../../../assets/img/aboutus/item_ren.png'),
            noteCn: '以人为本',
            noteEn: 'People Oriented',
            noteRu: 'человек'
          },
        ]
      }
    },
    methods: {
      init() {
        const wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 0,
          mobile: false,
          live: false
        })
        wow.init()
      },
      loadImg() {
        // this.$refs.cultureContent.style.height = this.$refs.cultureBanner.offsetHeight + 'px'
      }

    },
    mounted() {
      this.init()
    },
    computed: {
      ...mapGetters(['lang','isMobile']),
      getComponentName() {
        return 'AboutCompany'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .about-company {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 8rem;

    .title {
      font-size: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      line-height: 4.38rem;
    }

    .underline {
      max-width: 9.75rem;
      margin-top: 1.5rem;
    }

    .company {
      // display: flex;
      // justify-content: center;
      width: 100%;
      margin-top: 4.5rem;
      background: rgba(29, 38, 50, 1);
      position: relative;
      .introduction-ol {
        width: 50%;
        // background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
        padding-right:4.75rem;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        position: absolute;
        top:50%;
        transform: translate(0%,-50%);
        .introduction {
          display: flex;
          flex-direction: column;
          // margin-top: -2.25rem;
          p {
            font-size: 2rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            // line-height: 4.38rem;
            letter-spacing: 0.56rem;
            margin: 0;
          }
          span {
            display: block;
            max-width: 32.13rem;
            font-size: 0.88rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            line-height: 1.5rem;
            margin: 0.88rem 0 0 0;
            letter-spacing: 0.02rem;
          }
        }
      }

      img {
        // width: 50%;
        // max-width: 60rem;
      }
    }

    .slogan {
      // display: flex;
      // height: 50rem;
      // padding: 7.5rem 0;
      // max-width: 75rem;
      width: 100%;
      position: relative;
      .slogan-compent {
        // width: 100%;
        display: flex;
        // height: 100%;
        // left: 55%;
        // justify-items: center;
        // align-content: center;
        // flex-direction: column;
        // align-items: center;
        /*justify-content: center;*/
        // margin-left:67.5rem;
        position: absolute;
        // top: 0;
        width: 100%;
        height: 100%;
        // align-items: center;
        // transform: translate(0,-50%);
        // top:50%;
        // top: 50%;
        // transform: translate(-50%,-50%);
        &>div{
          align-self:center;
          // width:;
          margin-left: 52%;
        .mission, .vision {
          // margin-top: 7.5rem;
          div.title {
            font-size: 2rem;
            // font-family: Arial, Source Han Sans CN;
            font-weight:bold;
            color:#fff;
            line-height: 2.25rem;
            letter-spacing: 0.15rem;
            margin-bottom: 1rem;
          }

          div.tips {
            font-size: 0.88rem;
            // font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color:#fff;
            line-height: 1.875rem;
            letter-spacing: 0.19rem;
            white-space: pre-wrap;
          }
        }
        .vision{
          margin-top:5rem;
        }

      }
      }

      // img {
      //   max-width: 37.5rem;
      //   height: 37.5rem;
      // }
    }

    .culture {
      width: 100%;
      height: 100%;
      position: relative;

      .culture-content-ol {
        width: 100%;
        height: 100%;
        position: absolute;
        margin-top: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .culture-content {
          max-width: 75rem;
          width: 100%;

          p {
            font-size: 2rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            line-height: 4.38rem;
          }

          .culture-menu {
            max-width: 39rem;
            width: 100%;
            display: flex;
            flex-flow: wrap;
            margin-top: 2.625rem;

            .culture-item {
              display: flex;
              align-items: center;
              max-width: 19.5rem;
              width: 100%;
              margin: 0.75rem 0;
              img {
                /*width: 3.2rem;*/
                /*height: 3.2rem;*/
              }

              .note {
                display: flex;
                flex-direction: column;
                margin-left: 1.5rem;

                .note-cn {
                  font-size: 1.25rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: bold;
                  color: rgba(63, 74, 93, 1);
                  letter-spacing: 0.15rem;
                }

                .note-en {
                  font-size: 0.88rem;
                  font-family: Arial;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                }

                .note-ru {
                  font-size: 0.88rem;
                  font-family: Arial;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                }
              }
            }
          }
        }
      }
    }
  }

  .visible-xs {
    .about-company {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 2rem;

      .title {
        font-size: 1.5rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(63, 74, 93, 1);
        line-height: 3rem;
      }

      .company {
        // display: flex;
        // justify-content: center;
        // flex-direction: column;
        width: 100%;
        margin-top: 2rem;
        background: rgba(29, 38, 50, 1);
        position: relative;
        .introduction-ol {
          width: 100%;
          background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
          padding: 5%;
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          position: relative;
          top:0;
          transform: translate(0,0);
          .introduction {
            display: flex;
            flex-direction: column;
            margin-top: 0rem;


            p {
              font-size: 1rem;
              font-family: Arial, Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 2rem;
              letter-spacing: 0.3rem;
            }

            span {
              display: block;
              max-width: 100%;
              font-size: 0.8rem;
              font-family: Arial, Source Han Sans CN;
              font-weight: 300;
              color: rgba(255, 255, 255, 1);
              line-height: 1.5rem;
              margin: 0.5rem 0;
              letter-spacing: 0.01rem;

            }
          }
        }

        img {
          width: 100%;
          height: auto;
          max-width: 60rem;
        }
      }

      .slogan {
        // display: flex;
        // align-items: center;
        height: auto;
        padding: 0;
        max-width: 100%;
        width: 100%;
        position: relative;
        // margin: 5% 0;
        .slogan-compent {
          // width: 100%;
          display: flex;
          // flex-direction: column;
          // justify-content: center;
          // align-items: center;
          // margin-left: 0rem;
          position: absolute;
          width: 100%;
          height: 100%;
          // top:50%;
          // transform: translate(0,-50%);
          // left:50%;
          &>div{
           align-self: center;
           left:50%;
          .mission, .vision {
            // margin-top:2%;
            margin-top:0%;
            padding: 0 0%;
            div.title {
              font-size: 1rem;
              font-family: Arial, Source Han Sans CN;
              font-weight:bold;
              color: #fff;
              line-height:1.88rem;
              letter-spacing: 0.1rem;
              margin: 0;
              margin-bottom: 0.5rem;
            }
            div.tips {
              font-size: 0.8rem;
              font-family: Arial, Source Han Sans CN;
              font-weight: 300;
              color:#fff;
              line-height: 1rem;
              letter-spacing: 0.1rem;
              white-space: pre-wrap;
            }
          }
          .vision{
            margin-top:1rem;
          }
        }
        }
        // img {
        //   width: 55%;
        //   height: 55%;
        // }
      }

      .culture {
        width: 100%;
        height: 100%;
        position: relative;
        overflow-x: hidden;

        .culture-img {
          width: auto;
          height: 20rem;
        }

        .culture-content-ol {
          width: 100%;
          height: 100%;
          position: absolute;
          margin-top: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .culture-content {
            max-width: 90%;
            width: 100%;

            p {
              font-size: 1.5rem;
              font-family: Arial, Source Han Sans CN;
              font-weight: 400;
              color: rgba(63, 74, 93, 1);
              line-height: 3rem;
            }

            .culture-menu {
              width: 100%;
              display: flex;
              flex-flow: wrap;
              margin-top: 1rem;

              .culture-item {
                display: flex;
                align-items: center;
                max-width: 50%;
                width: 100%;
                margin: 0.5rem 0;

                img {
                  width: 2rem;
                  height: 2rem;
                }

                .note {
                  display: flex;
                  flex-direction: column;
                  margin-left: 1rem;

                  .note-cn {
                    font-size: 1rem;
                    font-family: Arial, Source Han Sans CN;
                    font-weight: bold;
                    color: rgba(63, 74, 93, 1);
                    letter-spacing: 0.1rem;
                  }

                  .note-en {
                    font-size: 0.6rem;
                    font-family: Arial;
                    font-weight: 400;
                    color: rgba(63, 74, 93, 1);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .english {

    .introduction, .mission, .vision {
      div{
        letter-spacing: 0 !important;
      }
    }

    .hidden-xs {
      .company {
        // min-height: 45rem;
      }

      .introduction {
        span {
          letter-spacing: 0 !important;
          max-width: 40rem !important;
          margin: 0.5rem 0  !important;
        }
        p{
           letter-spacing: 0 !important;
        }
      }

      .note{
        margin-left: 0 !important;
        .note-en {
          font-size: 1.25rem !important;
          font-family: Arial;
          font-weight: 400 !important;;
          color: #3f4a5d !important;;
        }
      }
    }

    .visible-xs {
       .title{
         font-size: 1.2rem;
       }
       .culture .culture-content-ol .culture-content p{
         font-size: 1.2rem;
       }
      .introduction {
        span {
          line-height: 1.3rem !important;
        }
        p{
           letter-spacing: 0 !important;
        }
      }

      .note{
        margin-left: 0 !important;
        .note-en {
          font-size: 0.6rem !important;
          font-family: Arial;
          font-weight: 400 !important;;
          color: #3f4a5d !important;;
        }
      }
      //
      .slogan{
        .vision .tips,.mission .tips{
          font-size:0.66rem !important;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/aboutus/AboutCompany.vue